import React from 'react'
import 'bootstrap/dist/css/bootstrap.css'

import Application from './Application'

const App = () => <Application />

App.displayName = 'App'
export default App
